<div class="game__container--animation" #game></div>
<div class="game__container--loader" *ngIf="loaderOn">
    <loader-image class="game__loader-image" [customLoaderData]="buttonLoaderImage"></loader-image>
</div>

<div class="game__container--info idle" *ngIf="roundState === ERoundState.Idle"
     [class.no-animation-mode]="noAnimationEnabled">
    <p class="game__text--game-info">{{'WAITING_FOR_NEXT_ROUND' | translate}}</p>
    <div class="game__container--round-loader">
        <div class="game__loader">
            <div #gameLoaderBar class="game__loader--inner"></div>
        </div>
    </div>
</div>

<div class="game__container--info" *ngIf="roundState !== ERoundState.Idle"
     [class.no-animation-mode]="noAnimationEnabled" game-number-color
     [class.pulse-animation]="roundState === ERoundState.Playing">
    <p class="game__text--game-info-multiplier">
        <span class="multiplier-label-text">{{'MULTIPLIER' | translate}}</span>
        <span class="multiplier-amount-text">x<span game-multiplier class="amount"></span></span>
    </p>
    <ng-container #multiplierParticleContainer></ng-container>
</div>

<ng-template #multiplierParticle>
    <img class="game__image--multiplier-particle" [src]="'assets/images/multiplier_particle.png'"/>
</ng-template>
<ng-template #multiplierParticleBig>
    <img class="game__image--multiplier-particle" [src]="'assets/images/multiplier_particle_big.png'"/>
</ng-template>
